var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetsIconsCriticalLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5459 14.4541C30.0777 16.9858 31.5 20.4196 31.5 24H23.9925C23.9925 22.4107 23.3611 20.8865 22.2373 19.7627C21.1135 18.6389 19.5893 18.0075 18 18.0075C16.4107 18.0075 14.8865 18.6389 13.7627 19.7627C12.6389 20.8865 12.0075 22.4107 12.0075 24H4.5C4.5 20.4196 5.92232 16.9858 8.45406 14.4541M27.5459 14.4541C25.0142 11.9223 21.5804 10.5 18 10.5M27.5459 14.4541L22.5 19.5M18 10.5C14.4196 10.5 10.9858 11.9223 8.45406 14.4541M18 10.5V18M8.45406 14.4541L13.5 19.5",
    stroke: "#383E42",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsIconsCriticalLight);
export default __webpack_public_path__ + "static/media/lets-icons_critical-light.5f4d88283df4c480791a2fc57860257d.svg";
export { ForwardRef as ReactComponent };